var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    'icon': true
  }, _obj[("icon--size--" + _vm.size)] = !_vm.isTight, _obj )},[_c(_vm.renderComponent,_vm._b({tag:"component",staticClass:"icon__source"},'component',_vm.attributes,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }